import { cva } from 'class-variance-authority';

export const DISPLAY_ERROR_CODES = ['invalid_format', 'custom'];

export const schemaFieldVariants = cva('', {
  variants: {
    variant: {
      inline: '',
      stacked: '',
    },
  },
  defaultVariants: {
    variant: 'inline',
  },
});
